import { useTranslation } from 'react-i18next';
import { TextField } from '../../TextField';
import { ArticleDraftResponse, ArticleRequest } from '../../../api/queries';
import { ContentEditor } from '../../ContentEditor/ContentEditor';
import type { JSONContent } from '@tiptap/react';
import classes from './CreateArticleForm.module.css';

type CreateArticleFormProps = {
  article: Partial<ArticleDraftResponse>;
  updateDraftArticle: <K extends keyof ArticleRequest>(
    key: K,
    value: ArticleRequest[K],
  ) => void;
  mode: 'edit' | 'create';
  isSuperAdmin: boolean;
};

export const CreateArticleForm = ({
  article,
  updateDraftArticle,
  mode,
  isSuperAdmin,
}: CreateArticleFormProps) => {
  const { t } = useTranslation();

  return (
    <div className={classes.form}>
      <div className={classes.titleContainer}>
        <TextField
          label={t('createArticleForm.title')}
          value={article.title ?? ''}
          onChange={(e) => updateDraftArticle('title', e.target.value)}
          type="text"
          required
          name={'title'}
        />
      </div>

      {mode === 'edit' && (
        <>
          <ContentEditor
            key={article.draftId ?? article.guideId ?? 0}
            content={article?.jsonContent}
            onChange={(content: JSONContent) =>
              updateDraftArticle('jsonContent', content as JSONContent)
            }
          />

          {isSuperAdmin && (
            <div className={classes.isGlobalGuide}>
              <input
                id="isGlobalGuide"
                type="checkbox"
                checked={article.isGlobalGuide ?? false}
                onChange={(e) =>
                  updateDraftArticle('isGlobalGuide', e.target.checked)
                }
              />
              <label className={classes.label} htmlFor="isGlobalGuide">
                Skrevet av Trustpulse (global artikkel)
              </label>
            </div>
          )}
        </>
      )}
    </div>
  );
};
